"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Zoom.default;
  }
});
Object.defineProperty(exports, "unstable_StrictModeZoom", {
  enumerable: true,
  get: function get() {
    return _StrictModeZoom.default;
  }
});

var _Zoom = _interopRequireDefault(require("./Zoom"));

var _StrictModeZoom = _interopRequireDefault(require("./StrictModeZoom"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Zoom/index.js
// module id = 341
// module chunks = 0